<div [@fadeInLeft] class="controls-box">
  <app-filter-container>
    <ng-content></ng-content>
  </app-filter-container>
</div>
